export const appDesktopCasinoCountryBlocker: string[] = ['TR', 'PL', 'HU', 'DE', 'NL', 'BE', 'FR', 'GR'];

export const appMobileCasinoCountryBlocker: string[] = [];
